import { useQuery } from '@tanstack/react-query';

import { getMailchimpAudiences } from '../api/audiences';
import type { MailchimpAudiencesResponse } from '../types';

export function useMailchimpAudiences(
  orgId: number | string | undefined,
  enabled = true
) {
  return useQuery<MailchimpAudiencesResponse>({
    queryKey: ['mailchimpAudiences', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getMailchimpAudiences(orgId);
    },
    enabled: !!orgId && enabled,
  });
}
